// extracted by mini-css-extract-plugin
export default {"backIcon":"styles_backIcon__itmnZ"};